/**
 * Broad research / discipline tags for onboarding and discovery.
 * Sorted A–Z; deduped.
 */
const RESEARCH_FIELD_RAW: string[] = [
  'Accounting',
  'Aerospace Engineering',
  'Agricultural Sciences',
  'AI/ML',
  'Algorithms',
  'Anthropology',
  'Applied Mathematics',
  'Archaeology',
  'Art History',
  'Artificial Intelligence',
  'Astronomy',
  'Astrophysics',
  'Atmospheric Science',
  'Behavioral Economics',
  'Biochemistry',
  'Bioengineering',
  'Bioethics',
  'Bioinformatics',
  'Biomedical Engineering',
  'Biophysics',
  'Biostatistics',
  'Biotechnology',
  'Cancer Biology',
  'Cell Biology',
  'Chemical Engineering',
  'Chemistry',
  'Civil Engineering',
  'Climate Science',
  'Cognitive Science',
  'Communication Studies',
  'Computational Biology',
  'Computational Chemistry',
  'Computational Linguistics',
  'Computational Neuroscience',
  'Computer Architecture',
  'Computer Graphics',
  'Computer Networks',
  'Computer Science',
  'Computer Vision',
  'Condensed Matter Physics',
  'Control Theory',
  'Criminology',
  'Cryptography',
  'Cybersecurity',
  'Data Science',
  'Demography',
  'Developmental Biology',
  'Development Economics',
  'Digital Humanities',
  'Earth Sciences',
  'Ecology',
  'Econometrics',
  'Economics',
  'Education',
  'Electrical Engineering',
  'Embedded Systems',
  'Energy Systems',
  'Environmental Engineering',
  'Environmental Science',
  'Epidemiology',
  'Ethics',
  'Ethnomusicology',
  'Evolutionary Biology',
  'Finance',
  'Fluid Dynamics',
  'Game Theory',
  'Gender Studies',
  'Genomics',
  'Geography',
  'Geology',
  'Geophysics',
  'Global Health',
  'Graph Theory',
  'HCI / UX Research',
  'High Energy Physics',
  'History',
  'Immunology',
  'Information Systems',
  'Information Theory',
  'International Relations',
  'Journalism',
  'Law',
  'Library & Information Science',
  'Linguistics',
  'Literary Studies',
  'Logic',
  'Machine Learning',
  'Macroeconomics',
  'Management',
  'Marketing',
  'Materials Science',
  'Mathematical Biology',
  'Mathematics',
  'Mechanical Engineering',
  'Medical Imaging',
  'Medicine',
  'Microbiology',
  'Microeconomics',
  'Molecular Biology',
  'Musicology',
  'Nanotechnology',
  'Natural Language Processing',
  'Neurobiology',
  'Neuroscience',
  'Nuclear Engineering',
  'Nuclear Physics',
  'Number Theory',
  'Nursing',
  'Oceanography',
  'Oncology',
  'Operations Research',
  'Optics',
  'Optimization',
  'Organic Chemistry',
  'Paleontology',
  'Particle Physics',
  'Pharmacology',
  'Philosophy',
  'Philosophy of Science',
  'Photonics',
  'Physical Chemistry',
  'Physics',
  'Physiology',
  'Plant Biology',
  'Plasma Physics',
  'Political Science',
  'Probability Theory',
  'Programming Languages',
  'Psychiatry',
  'Psychology',
  'Public Administration',
  'Public Health',
  'Public Policy',
  'Quantum Computing',
  'Quantum Information',
  'Quantum Physics',
  'Religious Studies',
  'Robotics',
  'Science & Technology Studies',
  'Signal Processing',
  'Social Psychology',
  'Social Work',
  'Sociology',
  'Software Engineering',
  'Solid State Physics',
  'Sports Science',
  'Statistics',
  'Structural Biology',
  'Supply Chain',
  'Sustainability Science',
  'Synthetic Biology',
  'Systems Biology',
  'Theoretical Computer Science',
  'Theoretical Physics',
  'Thermodynamics',
  'Transportation Engineering',
  'Urban Planning',
  'Urban Studies',
  'Virology',
  'Zoology',
];

export const RESEARCH_FIELD_CATALOG: readonly string[] = Array.from(
  new Set(RESEARCH_FIELD_RAW)
).sort((a, b) => a.localeCompare(b));
